var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3",class:{ 'd-none': _vm.item.displayOn && !_vm.display_none_check}},[_c('p',[_vm._v("Make chat here")])])
}
var staticRenderFns = []

export { render, staticRenderFns }